/**
 * 表情坐标配置
 * 参数说明：
 * startX 距离左边顶点的X轴的开始坐标
 * endX 距离左边顶点的x轴的结束坐标
 * startY 距离左边顶点的y轴开始坐标
 * endY 距离左边顶点的y轴结束坐标
 * emoji 微信表情，格式[表情名称]
 */

export const emojiAxisConfig = [
    {
        startX: 0,
        endX: 28,
        startY: 0,
        endY: 28,
        emoji: '[微笑]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 0,
        endY: 28,
        emoji: '[撇嘴]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 0,
        endY: 28,
        emoji: '[色]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 0,
        endY: 28,
        emoji: '[发呆]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 0,
        endY: 28,
        emoji: '[得意]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 0,
        endY: 28,
        emoji: '[流泪]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 0,
        endY: 28,
        emoji: '[害羞]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 0,
        endY: 28,
        emoji: '[闭嘴]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 0,
        endY: 28,
        emoji: '[睡]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 0,
        endY: 28,
        emoji: '[大哭]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 0,
        endY: 28,
        emoji: '[尴尬]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 0,
        endY: 28,
        emoji: '[发怒]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 0,
        endY: 28,
        emoji: '[调皮]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 0,
        endY: 28,
        emoji: '[呲牙]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 0,
        endY: 28,
        emoji: '[惊讶]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 29,
        endY: 57,
        emoji: '[难过]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 29,
        endY: 57,
        emoji: '[酷]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 29,
        endY: 57,
        emoji: '[囧]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 29,
        endY: 57,
        emoji: '[抓狂]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 29,
        endY: 57,
        emoji: '[吐]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 29,
        endY: 57,
        emoji: '[偷笑]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 29,
        endY: 57,
        emoji: '[愉快]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 29,
        endY: 57,
        emoji: '[白眼]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 29,
        endY: 57,
        emoji: '[傲慢]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 29,
        endY: 57,
        emoji: '[饥饿]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 29,
        endY: 57,
        emoji: '[困]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 29,
        endY: 57,
        emoji: '[惊恐]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 29,
        endY: 57,
        emoji: '[流汗]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 29,
        endY: 57,
        emoji: '[憨笑]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 29,
        endY: 57,
        emoji: '[悠闲]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 58,
        endY: 87,
        emoji: '[奋斗]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 58,
        endY: 87,
        emoji: '[咒骂]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 58,
        endY: 87,
        emoji: '[疑问]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 58,
        endY: 87,
        emoji: '[嘘]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 58,
        endY: 87,
        emoji: '[晕]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 58,
        endY: 87,
        emoji: '[疯了]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 58,
        endY: 87,
        emoji: '[衰]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 58,
        endY: 87,
        emoji: '[骷髅]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 58,
        endY: 87,
        emoji: '[敲打]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 58,
        endY: 87,
        emoji: '[再见]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 58,
        endY: 87,
        emoji: '[擦汗]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 58,
        endY: 87,
        emoji: '[抠鼻]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 58,
        endY: 87,
        emoji: '[鼓掌]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 58,
        endY: 87,
        emoji: '[糗大了]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 58,
        endY: 87,
        emoji: '[坏笑]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 87,
        endY: 116,
        emoji: '[左哼哼]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 87,
        endY: 116,
        emoji: '[右哼哼]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 87,
        endY: 116,
        emoji: '[哈欠]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 87,
        endY: 116,
        emoji: '[鄙视]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 87,
        endY: 116,
        emoji: '[委屈]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 87,
        endY: 116,
        emoji: '[快哭了]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 87,
        endY: 116,
        emoji: '[阴险]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 87,
        endY: 116,
        emoji: '[亲亲]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 87,
        endY: 116,
        emoji: '[吓]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 87,
        endY: 116,
        emoji: '[可怜]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 87,
        endY: 116,
        emoji: '[菜刀]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 87,
        endY: 116,
        emoji: '[西瓜]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 87,
        endY: 116,
        emoji: '[啤酒]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 87,
        endY: 116,
        emoji: '[篮球]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 87,
        endY: 116,
        emoji: '[乒乓]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 116,
        endY: 145,
        emoji: '[咖啡]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 116,
        endY: 145,
        emoji: '[饭]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 116,
        endY: 145,
        emoji: '[猪头]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 116,
        endY: 145,
        emoji: '[玫瑰]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 116,
        endY: 145,
        emoji: '[凋谢]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 116,
        endY: 145,
        emoji: '[嘴唇]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 116,
        endY: 145,
        emoji: '[爱心]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 116,
        endY: 145,
        emoji: '[心碎]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 116,
        endY: 145,
        emoji: '[蛋糕]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 116,
        endY: 145,
        emoji: '[闪电]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 116,
        endY: 145,
        emoji: '[炸弹]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 116,
        endY: 145,
        emoji: '[刀]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 116,
        endY: 145,
        emoji: '[足球]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 116,
        endY: 145,
        emoji: '[瓢虫]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 116,
        endY: 145,
        emoji: '[便便]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 145,
        endY: 174,
        emoji: '[月亮]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 145,
        endY: 174,
        emoji: '[太阳]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 145,
        endY: 174,
        emoji: '[礼物]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 145,
        endY: 174,
        emoji: '[拥抱]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 145,
        endY: 174,
        emoji: '[强]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 145,
        endY: 174,
        emoji: '[弱]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 145,
        endY: 174,
        emoji: '[握手]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 145,
        endY: 174,
        emoji: '[胜利]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 145,
        endY: 174,
        emoji: '[抱拳]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 145,
        endY: 174,
        emoji: '[勾引]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 145,
        endY: 174,
        emoji: '[拳头]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 145,
        endY: 174,
        emoji: '[差劲]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 145,
        endY: 174,
        emoji: '[爱你]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 145,
        endY: 174,
        emoji: '[No]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 145,
        endY: 174,
        emoji: '[OK]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 174,
        endY: 205,
        emoji: '[爱情]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 174,
        endY: 205,
        emoji: '[飞吻]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 174,
        endY: 205,
        emoji: '[跳跳]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 174,
        endY: 205,
        emoji: '[发抖]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 174,
        endY: 205,
        emoji: '[怄火]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 174,
        endY: 205,
        emoji: '[转圈]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 174,
        endY: 205,
        emoji: '[磕头]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 174,
        endY: 205,
        emoji: '[回头]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 174,
        endY: 205,
        emoji: '[跳绳]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 174,
        endY: 205,
        emoji: '[投降]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 174,
        endY: 205,
        emoji: '[激动]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 174,
        endY: 205,
        emoji: '[乱舞]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 174,
        endY: 205,
        emoji: '[献吻]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 174,
        endY: 205,
        emoji: '[左太极]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 174,
        endY: 205,
        emoji: '[右太极]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 204,
        endY: 233,
        emoji: '[嘿哈]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 204,
        endY: 233,
        emoji: '[捂脸]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 204,
        endY: 233,
        emoji: '[奸笑]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 204,
        endY: 233,
        emoji: '[机智]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 204,
        endY: 233,
        emoji: '[皱眉]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 204,
        endY: 233,
        emoji: '[耶]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 204,
        endY: 233,
        emoji: '[吃瓜]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 204,
        endY: 233,
        emoji: '[加油]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 204,
        endY: 233,
        emoji: '[汗]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 204,
        endY: 233,
        emoji: '[天啊]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 204,
        endY: 233,
        emoji: '[Emm]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 204,
        endY: 233,
        emoji: '[社会社会]'
    },
    {
        startX: 348,
        endX: 376,
        startY: 204,
        endY: 233,
        emoji: '[旺柴]'
    },
    {
        startX: 377,
        endX: 405,
        startY: 204,
        endY: 233,
        emoji: '[好的]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 204,
        endY: 233,
        emoji: '[打脸]'
    },
    {
        startX: 0,
        endX: 28,
        startY: 232,
        endY: 261,
        emoji: '[加油加油]'
    },
    {
        startX: 29,
        endX: 57,
        startY: 232,
        endY: 261,
        emoji: '[哇]'
    },
    {
        startX: 58,
        endX: 86,
        startY: 232,
        endY: 261,
        emoji: '[翻白眼]'
    },
    {
        startX: 87,
        endX: 115,
        startY: 232,
        endY: 261,
        emoji: '[666]'
    },
    {
        startX: 116,
        endX: 144,
        startY: 232,
        endY: 261,
        emoji: '[让我看看]'
    },
    {
        startX: 145,
        endX: 173,
        startY: 232,
        endY: 261,
        emoji: '[叹气]'
    },
    {
        startX: 174,
        endX: 202,
        startY: 232,
        endY: 261,
        emoji: '[苦涩]'
    },
    {
        startX: 203,
        endX: 231,
        startY: 232,
        endY: 261,
        emoji: '[裂开]'
    },
    {
        startX: 232,
        endX: 260,
        startY: 232,
        endY: 261,
        emoji: '[红包]'
    },
    {
        startX: 261,
        endX: 289,
        startY: 232,
        endY: 261,
        emoji: '[發]'
    },
    {
        startX: 290,
        endX: 318,
        startY: 232,
        endY: 261,
        emoji: '[福]'
    },
    {
        startX: 319,
        endX: 347,
        startY: 232,
        endY: 261,
        emoji: '😄'
    },
    {
        startX: 348,
        endX: 376,
        startY: 232,
        endY: 261,
        emoji: '😊'
    },
    {
        startX: 377,
        endX: 405,
        startY: 232,
        endY: 261,
        emoji: '[大笑]'
    },
    {
        startX: 406,
        endX: 434,
        startY: 232,
        endY: 261,
        emoji: '☺'
    },
    {
        startX: 0,
        endX: 28,
        startY: 262,
        endY: 291,
        emoji: '😉'
    },
    {
        startX: 29,
        endX: 57,
        startY: 262,
        endY: 291,
        emoji: '😍'
    },
    {
        startX: 58,
        endX: 86,
        startY: 262,
        endY: 291,
        emoji: '😘'
    },
    {
        startX: 87,
        endX: 115,
        startY: 262,
        endY: 291,
        emoji: '😚'
    },
    {
        startX: 116,
        endX: 144,
        startY: 262,
        endY: 291,
        emoji: '😳'
    },
    {
        startX: 145,
        endX: 173,
        startY: 262,
        endY: 291,
        emoji: '😁'
    },
    {
        startX: 174,
        endX: 202,
        startY: 262,
        endY: 291,
        emoji: '😌'
    },
    {
        startX: 203,
        endX: 231,
        startY: 262,
        endY: 291,
        emoji: '😜'
    },
    {
        startX: 232,
        endX: 260,
        startY: 262,
        endY: 291,
        emoji: '😝'
    },
    {
        startX: 261,
        endX: 289,
        startY: 262,
        endY: 291,
        emoji: '😒'
    },
    {
        startX: 290,
        endX: 318,
        startY: 262,
        endY: 291,
        emoji: '😏'
    },
    {
        startX: 319,
        endX: 347,
        startY: 262,
        endY: 291,
        emoji: '😓'
    },
    {
        startX: 348,
        endX: 376,
        startY: 262,
        endY: 291,
        emoji: '😔'
    },
    {
        startX: 377,
        endX: 405,
        startY: 262,
        endY: 291,
        emoji: '😞'
    },
    {
        startX: 406,
        endX: 434,
        startY: 262,
        endY: 291,
        emoji: '😖'
    },
    {
        startX: 0,
        endX: 28,
        startY: 291,
        endY: 320,
        emoji: '😥'
    },
    {
        startX: 29,
        endX: 57,
        startY: 291,
        endY: 320,
        emoji: '😰'
    },
    {
        startX: 58,
        endX: 86,
        startY: 291,
        endY: 320,
        emoji: '😨'
    },
    {
        startX: 87,
        endX: 115,
        startY: 291,
        endY: 320,
        emoji: '😣'
    },
    {
        startX: 116,
        endX: 144,
        startY: 291,
        endY: 320,
        emoji: '😢'
    },
    {
        startX: 145,
        endX: 173,
        startY: 291,
        endY: 320,
        emoji: '😭'
    },
    {
        startX: 174,
        endX: 202,
        startY: 291,
        endY: 320,
        emoji: '😂'
    },
    {
        startX: 203,
        endX: 231,
        startY: 291,
        endY: 320,
        emoji: '😵'
    },
    {
        startX: 232,
        endX: 260,
        startY: 291,
        endY: 320,
        emoji: '😱'
    },
    {
        startX: 261,
        endX: 289,
        startY: 291,
        endY: 320,
        emoji: '😠'
    },
    {
        startX: 290,
        endX: 318,
        startY: 291,
        endY: 320,
        emoji: '😡'
    },
    {
        startX: 319,
        endX: 347,
        startY: 291,
        endY: 320,
        emoji: '😪'
    },
    {
        startX: 348,
        endX: 376,
        startY: 291,
        endY: 320,
        emoji: '😷'
    },
    {
        startX: 377,
        endX: 405,
        startY: 291,
        endY: 320,
        emoji: '👿'
    },
    {
        startX: 406,
        endX: 434,
        startY: 291,
        endY: 320,
        emoji: '👽'
    },
    {
        startX: 0,
        endX: 28,
        startY: 320,
        endY: 349,
        emoji: '❤'
    },
    {
        startX: 29,
        endX: 57,
        startY: 320,
        endY: 349,
        emoji: '💔'
    },
    {
        startX: 58,
        endX: 86,
        startY: 320,
        endY: 349,
        emoji: '💘'
    },
    {
        startX: 87,
        endX: 115,
        startY: 320,
        endY: 349,
        emoji: '✨'
    },
    {
        startX: 116,
        endX: 144,
        startY: 320,
        endY: 349,
        emoji: '🌟'
    },
    {
        startX: 145,
        endX: 173,
        startY: 320,
        endY: 349,
        emoji: '❕'
    },
    {
        startX: 174,
        endX: 202,
        startY: 320,
        endY: 349,
        emoji: '❔'
    },
    {
        startX: 203,
        endX: 231,
        startY: 320,
        endY: 349,
        emoji: '💤'
    },
    {
        startX: 232,
        endX: 260,
        startY: 320,
        endY: 349,
        emoji: '💦'
    },
    {
        startX: 261,
        endX: 289,
        startY: 320,
        endY: 349,
        emoji: '🎵'
    },
    {
        startX: 290,
        endX: 318,
        startY: 320,
        endY: 349,
        emoji: '🔥'
    },
    {
        startX: 319,
        endX: 347,
        startY: 320,
        endY: 349,
        emoji: '💩'
    },
    {
        startX: 348,
        endX: 376,
        startY: 320,
        endY: 349,
        emoji: '👍'
    },
    {
        startX: 377,
        endX: 405,
        startY: 320,
        endY: 349,
        emoji: '👎'
    },
    {
        startX: 406,
        endX: 434,
        startY: 320,
        endY: 349,
        emoji: '👊'
    },
    {
        startX: 0,
        endX: 28,
        startY: 349,
        endY: 378,
        emoji: '✌'
    },
    {
        startX: 29,
        endX: 57,
        startY: 349,
        endY: 378,
        emoji: '👆'
    },
    {
        startX: 58,
        endX: 86,
        startY: 349,
        endY: 378,
        emoji: '👇'
    },
    {
        startX: 87,
        endX: 115,
        startY: 349,
        endY: 378,
        emoji: '👉'
    },
    {
        startX: 116,
        endX: 144,
        startY: 349,
        endY: 378,
        emoji: '👈'
    },
    {
        startX: 145,
        endX: 173,
        startY: 349,
        endY: 378,
        emoji: '☝'
    },
    {
        startX: 174,
        endX: 202,
        startY: 349,
        endY: 378,
        emoji: '💪'
    },
    {
        startX: 203,
        endX: 231,
        startY: 349,
        endY: 378,
        emoji: '💏'
    },
    {
        startX: 232,
        endX: 260,
        startY: 349,
        endY: 378,
        emoji: '💑'
    },
    {
        startX: 261,
        endX: 289,
        startY: 349,
        endY: 378,
        emoji: '👦'
    },
    {
        startX: 290,
        endX: 318,
        startY: 349,
        endY: 378,
        emoji: '👧'
    },
    {
        startX: 319,
        endX: 347,
        startY: 349,
        endY: 378,
        emoji: '👩'
    },
    {
        startX: 348,
        endX: 376,
        startY: 349,
        endY: 378,
        emoji: '👨'
    },
    {
        startX: 377,
        endX: 405,
        startY: 349,
        endY: 378,
        emoji: '👼'
    },
    {
        startX: 406,
        endX: 434,
        startY: 349,
        endY: 378,
        emoji: '💀'
    },
]
